export const AFFILIATE_REL = 'sponsored nofollow noopener';
export const AFFILIATE_TARGET = '_blank';

export const AFFILIATE_SLUGS = [
  'botify-ai',
  'candy-ai',
  'character-ai',
  'charstar-ai',
  'darlink-ai',
  'dreamgf',
  'fantasygf',
  'golove-ai',
  'gptgirlfriend',
  'herahaven-ai',
  'intimate-ai',
  'justsext',
  'kupid-ai',
  'lovescape-ai',
  'luvr-ai',
  'muah-ai',
  'mylovely-ai',
  'nectar-ai',
  'nomi-ai',
  'ourdream-ai',
  'replika-ai',
  'romantic-ai',
  'rubii-ai',
  'soulgen-ai',
  'soulkyn',
  'spicy-chat-ai',
  'swipey-ai',
  'uncensy',
  'ai-girlfriend-com',
  'couple-me',
  'ai-trans-chat',
  'lovechat-ai',
  'makegirl-ai',
  'krushchat-ai',
  'heaven-ai',
  'secretcrush-ai',
  'yollo-ai',
  'ai-allure',
  'onlygfs-ai',
  'cherrypop-ai',
  'dondi-ai',
  'dreamle',
  'eternal-ai',
  'kalon-ai',
  'kissable',
  'secrets-ai',
  'sweetdream-ai',
  'whatslove-ai',
  'xomi',
  'reverie',
  'xeve-ai',
  'xchar',
  'joi-ai',
  'virtualover',
  'openlover',
  'xotic-ai',
  'linky-ai',
  'polybuzz-ai',
  'talkie-ai',
  'dream-companion',
  'aigirlfriends-ai',
  'mybabes-ai',
  'infatuated-ai',
  'bonza-chat',
  'funfun-ai',
  'lustgf',
  'heyreal-ai',
  'virtualcrush',
  'justmet',
  'selira-ai',
  'magi-ai',
  'virtualgf',
  'heygf-ai',
  'soulmate',
  'camsoda-ai',
  'flirtcam-ai',
  'lovel-ai',
  'promptchan',
  'desirex-ai',
  'moonmate',
  'kindroid',
  'nsfwchatbot',
  'nextpart-ai',
  'lollipop-chat',
] as const;

export type AffiliateSlug = (typeof AFFILIATE_SLUGS)[number];

export const AFFILIATE_NAMES: Record<AffiliateSlug, string> = {
  'botify-ai': 'Botify AI',
  'candy-ai': 'Candy AI',
  'character-ai': 'Character AI',
  'charstar-ai': 'Charstar AI',
  'darlink-ai': 'DarLink AI',
  dreamgf: 'DreamGF',
  fantasygf: 'FantasyGF',
  'golove-ai': 'GoLove AI',
  gptgirlfriend: 'GPTGirlfriend',
  'herahaven-ai': 'HeraHaven AI',
  'intimate-ai': 'Intimate AI',
  justsext: 'JustSext',
  'kupid-ai': 'Kupid AI',
  'lovescape-ai': 'Lovescape AI',
  'luvr-ai': 'Luvr AI',
  'muah-ai': 'Muah AI',
  'mylovely-ai': 'MyLovely AI',
  'nectar-ai': 'Nectar AI',
  'nomi-ai': 'Nomi AI',
  'ourdream-ai': 'OurDream AI',
  'replika-ai': 'Replika AI',
  'romantic-ai': 'Romantic AI',
  'rubii-ai': 'Rubii AI',
  'soulgen-ai': 'SoulGen AI',
  soulkyn: 'Soulkyn',
  'spicy-chat-ai': 'SpicyChat AI',
  'swipey-ai': 'Swipey AI',
  uncensy: 'Uncensy',
  'ai-girlfriend-com': 'AI Girlfriend',
  'couple-me': 'Couple.me',
  'ai-trans-chat': 'AI Trans Chat',
  'lovechat-ai': 'LoveChat',
  'makegirl-ai': 'MakeGirl AI',
  'krushchat-ai': 'KrushChat',
  'heaven-ai': 'HeavenAI',
  'secretcrush-ai': 'SecretCrush',
  'yollo-ai': 'Yollo AI',
  'ai-allure': 'AI Allure',
  'onlygfs-ai': 'OnlyGFs',
  'cherrypop-ai': 'CherryPop AI',
  'dondi-ai': 'Dondi AI',
  dreamle: 'Dreamle',
  'eternal-ai': 'Eternal AI',
  'kalon-ai': 'Kalon AI',
  kissable: 'Kissable',
  'secrets-ai': 'Secrets AI',
  'sweetdream-ai': 'SweetDream AI',
  'whatslove-ai': 'WhatsLove AI',
  xomi: 'XOMI',
  reverie: 'Reverie',
  'xeve-ai': 'xeve.ai',
  xchar: 'XCHAR',
  'joi-ai': 'Joi AI',
  virtualover: 'VirtuaLover',
  openlover: 'OpenLover',
  'xotic-ai': 'xotic.ai',
  'linky-ai': 'Linky AI',
  'polybuzz-ai': 'PolyBuzz AI',
  'talkie-ai': 'Talkie AI',
  'dream-companion': 'Dream Companion',
  'aigirlfriends-ai': 'AIGirlfriends.ai',
  'mybabes-ai': 'MyBabes.ai',
  'infatuated-ai': 'Infatuated AI',
  'bonza-chat': 'Bonza.Chat',
  'funfun-ai': 'FunFun AI',
  lustgf: 'LustGF',
  'heyreal-ai': 'HeyReal AI',
  virtualcrush: 'VirtualCrush',
  justmet: 'JustMet',
  'selira-ai': 'Selira AI',
  'magi-ai': 'MAGI AI',
  virtualgf: 'VirtualGF',
  'heygf-ai': 'HeyGF.ai',
  soulmate: 'Soulmate',
  'camsoda-ai': 'CamSoda AI',
  'flirtcam-ai': 'FlirtCam AI',
  'lovel-ai': 'Lovel.ai',
  promptchan: 'Promptchan',
  'desirex-ai': 'Desirex AI',
  moonmate: 'Moonmate',
  kindroid: 'Kindroid',
  nsfwchatbot: 'NSFWchatbot',
  'nextpart-ai': 'Nextpart AI',
  'lollipop-chat': 'lollipop.chat',
};

const AFFILIATE_SLUG_SET = new Set<string>(AFFILIATE_SLUGS);

const REVIEW_SLUG_TO_AFFILIATE_SLUG: Record<string, AffiliateSlug> = {
  'botify-ai-review': 'botify-ai',
  'candy-ai-review': 'candy-ai',
  'charstar-ai-review': 'charstar-ai',
  'character-ai-review': 'character-ai',
  'darlink-ai-review': 'darlink-ai',
  'dreamgf-review': 'dreamgf',
  'fantasygf-review': 'fantasygf',
  'golove-ai-review': 'golove-ai',
  'gptgirlfriend-review': 'gptgirlfriend',
  'herahaven-ai-review': 'herahaven-ai',
  'intimate-ai-review': 'intimate-ai',
  'justsext-review': 'justsext',
  'kupid-ai-review': 'kupid-ai',
  'lovescape-ai-review': 'lovescape-ai',
  'luvr-ai-review': 'luvr-ai',
  'muah-ai-review': 'muah-ai',
  'mylovely-ai-review': 'mylovely-ai',
  'nectar-ai-review': 'nectar-ai',
  'nomi-ai-review': 'nomi-ai',
  'ourdream-ai-review': 'ourdream-ai',
  'replika-ai-review': 'replika-ai',
  'romantic-ai-review': 'romantic-ai',
  'rubii-ai-review': 'rubii-ai',
  'soulgen-ai-review': 'soulgen-ai',
  'soulkyn-review': 'soulkyn',
  'spicy-chat-ai-review': 'spicy-chat-ai',
  'swipey-ai': 'swipey-ai',
  'uncensy-review': 'uncensy',
  'ai-girlfriend-com-review': 'ai-girlfriend-com',
  'couple-me-review': 'couple-me',
  'ai-trans-chat-review': 'ai-trans-chat',
  'lovechat-ai-review': 'lovechat-ai',
  'makegirl-ai-review': 'makegirl-ai',
  'krushchat-ai-review': 'krushchat-ai',
  'heaven-ai-review': 'heaven-ai',
  'secretcrush-ai-review': 'secretcrush-ai',
  'yollo-ai-review': 'yollo-ai',
  'ai-allure-review': 'ai-allure',
  'onlygfs-ai-review': 'onlygfs-ai',
  'cherrypop-ai-review': 'cherrypop-ai',
  'dondi-ai-review': 'dondi-ai',
  'dreamle-review': 'dreamle',
  'eternal-ai-review': 'eternal-ai',
  'kalon-ai-review': 'kalon-ai',
  'kissable-review': 'kissable',
  'secrets-ai-review': 'secrets-ai',
  'sweetdream-ai-review': 'sweetdream-ai',
  'whatslove-ai-review': 'whatslove-ai',
  'xomi-review': 'xomi',
  'reverie-review': 'reverie',
  'xeve-ai-review': 'xeve-ai',
  'xchar-review': 'xchar',
  'joi-ai-review': 'joi-ai',
  'virtualover-review': 'virtualover',
  'openlover-review': 'openlover',
  'xotic-ai-review': 'xotic-ai',
  'linky-ai-review': 'linky-ai',
  'polybuzz-ai-review': 'polybuzz-ai',
  'talkie-ai-review': 'talkie-ai',
  'dream-companion-review': 'dream-companion',
  'aigirlfriends-ai-review': 'aigirlfriends-ai',
  'mybabes-ai-review': 'mybabes-ai',
  'infatuated-ai-review': 'infatuated-ai',
  'bonza-chat-review': 'bonza-chat',
  'funfun-ai-review': 'funfun-ai',
  'lustgf-review': 'lustgf',
  'heyreal-ai-review': 'heyreal-ai',
  'virtualcrush-review': 'virtualcrush',
  'justmet-review': 'justmet',
  'selira-ai-review': 'selira-ai',
  'magi-ai-review': 'magi-ai',
  'virtualgf-review': 'virtualgf',
  'heygf-ai-review': 'heygf-ai',
  'soulmate-review': 'soulmate',
  'camsoda-ai-review': 'camsoda-ai',
  'flirtcam-ai-review': 'flirtcam-ai',
  'lovel-ai-review': 'lovel-ai',
  'promptchan-review': 'promptchan',
  'desirex-ai-review': 'desirex-ai',
  'moonmate-review': 'moonmate',
  'nextpart-ai-review': 'nextpart-ai',
  'lollipop-chat-review': 'lollipop-chat',
};

export const getAffiliateHref = (slug: AffiliateSlug): `/go/${AffiliateSlug}` => `/go/${slug}`;

export const getAffiliateSlugFromReviewSlug = (reviewSlug: string): AffiliateSlug | null =>
  REVIEW_SLUG_TO_AFFILIATE_SLUG[reviewSlug] ?? null;

const parseAffiliateSlug = (value: string): AffiliateSlug | null =>
  AFFILIATE_SLUG_SET.has(value) ? (value as AffiliateSlug) : null;

export const getAffiliateSlugFromHref = (href: string): AffiliateSlug | null => {
  if (!href) return null;

  if (href.startsWith('/go/')) {
    return parseAffiliateSlug(href.replace(/^\/go\//, '').split(/[?#]/, 1)[0] ?? '');
  }

  try {
    const url = new URL(href);
    if (url.hostname === 'heavengirlfriend.com' || url.hostname === 'www.heavengirlfriend.com') {
      return parseAffiliateSlug(url.pathname.replace(/^\/go\//, '').split(/[?#]/, 1)[0] ?? '');
    }
  } catch {
    return null;
  }

  return null;
};

export const isAffiliateHref = (href: string): boolean => getAffiliateSlugFromHref(href) !== null;

const AFFILIATE_DISABLED_REVIEW_SLUGS = new Set(['muah-ai-review']);

export const toAffiliateHref = (href: string, reviewSlug?: string): string => {
  if (reviewSlug && AFFILIATE_DISABLED_REVIEW_SLUGS.has(reviewSlug)) {
    return '';
  }

  if (!href) return href;

  const fromHref = getAffiliateSlugFromHref(href);
  if (fromHref === 'muah-ai') return '';
  if (fromHref) return getAffiliateHref(fromHref);

  if (reviewSlug) {
    const fromReviewSlug = getAffiliateSlugFromReviewSlug(reviewSlug);
    if (fromReviewSlug) return getAffiliateHref(fromReviewSlug);
  }

  return href;
};
